<template>
  <div id="footer" class="footer">
    &copy; 2024 - Bank Soal Fakultas Kedokteran Universitas AlKhairaat Palu -
    All Rights Reserved
  </div>
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";

export default {
  name: "FooterPage",
  data() {
    return {
      pageOptions: PageOptions,
    };
  },
};
</script>
